const FRIENDLY_LABELS: Record<string, string> = {
  TECHNICAL_EVIDENCE_PACKAGE: 'Technical evidence package',
  FINAL_AUDITOR_PACKAGE: 'Final auditor package',
  COMPLETED_EVIDENCE_PACKAGE: 'Completed evidence package',

  TECHNICAL_BASELINE: 'Technical baseline',
  FINAL_AUDITOR_READY: 'Final auditor ready',
  CLIENT_ACTION_REQUIRED: 'Client action required',

  AUDITOR_PACKAGE_READY: 'Final auditor package ready',
  COMPLETED_EVIDENCE_PACKAGE_BUILD_REQUESTED: 'Completed evidence package requested',
  COMPLETED_EVIDENCE_PACKAGE_BUILD_IN_PROGRESS: 'Completed evidence package building',
  COMPLETED_EVIDENCE_PACKAGE_BUILD_FAILED: 'Completed evidence package failed',
  COMPLETED_EVIDENCE_PACKAGE_UPLOADED_TO_INTAKE: 'Evidence package uploaded',
  PACKAGE_INDEXED: 'Package indexed',
  DOWNLOAD_LINK_SENT: 'Download link sent',
  EVIDENCE_PACKAGE_UPLOADED: 'Evidence package uploaded',
  FINAL_PACKAGE_DELIVERED: 'Final package delivered',
  PROCESSED_FINAL_PACKAGE_READY: 'Processed final package ready',
  CLIENT_UPLOAD_REQUESTED: 'Client upload requested',
  CLIENT_UPLOAD_PENDING: 'Client upload pending',
  CLIENT_UPLOAD_REQUIRED: 'Client upload required',
  CLIENT_APPROVAL_REQUESTED: 'Client approval requested',
  CLIENT_APPROVAL_EMAIL_SENT: 'Client approval email sent',
  CLIENT_APPROVED_EVIDENCE_GENERATION: 'Approved update & evidence',
  UPLOAD_ACCESS_KEY_CREATED: 'Upload access key created',
  UPLOAD_URL_GENERATED: 'Upload URL generated',
  PACKAGE_DOWNLOAD_URL_GENERATED: 'Package download URL generated',
  REPORT_GENERATION_RUNNING: 'Report generation running',
  REPORT_GENERATION_SKIPPED: 'Report generation skipped',
  ORCHESTRATION_STARTED: 'Orchestration started',
  ORCHESTRATION_FAILED: 'Orchestration failed',
  WORKSPACES_QUOTA_PREFLIGHT_STARTED: 'WorkSpaces quota preflight started',
  WORKSPACES_QUOTA_PREFLIGHT_SUCCEEDED: 'WorkSpaces quota preflight passed',
  WORKSPACES_QUOTA_PREFLIGHT_SKIPPED: 'WorkSpaces quota preflight skipped',
  WORKSPACES_QUOTA_PREFLIGHT_FAILED: 'WorkSpaces quota preflight failed',
  WORKSPACES_QUOTA_EXCEEDED: 'WorkSpaces quota exceeded',
  WORKSPACES_QUOTA_PREFLIGHT_UNAVAILABLE: 'WorkSpaces quota preflight unavailable',
  WORKSPACES_QUOTA_PREFLIGHT_CONFIG_ERROR: 'WorkSpaces quota preflight configuration error',
  EVIDENCE_ARCHIVE_REBUILT: 'Evidence archive rebuilt',
  EVIDENCE_VALIDATION_STARTED: 'Evidence validation started',
  EVIDENCE_VALIDATED: 'Evidence validated',
  CONTROL_MATRIX_STARTED: 'Control matrix started',
  CONTROL_MATRIX_BUILT: 'Control matrix built',
  PROCESSING: 'Processing',
  VALIDATING: 'Validating',
  QUEUED: 'Queued',
  RECEIVED: 'Upload received',
  UPLOADED: 'Uploaded',
  PENDING: 'Pending',
  ACTIVE: 'Active',
  DISABLED: 'Disabled',
  FAILED: 'Failed',
  ERROR: 'Error',
  PASS: 'PASS',
  PARTIAL: 'PARTIAL',
  FAIL: 'FAIL',
  NOT_APPLICABLE: 'N/A',
  HUMAN_PROCESS_REQUIRED: 'Human/process required',
  POSSIBLE_NOT_APPLICABLE: 'Possible not applicable',
  FINAL_ASSESSOR_REVIEW_PENDING: 'Final assessor review pending',

  PORTAL_NOTIFICATION_READY: 'Portal notification ready',
  WORKSPACE_COMPLETED_EVIDENCE_PACKAGE_BUILD_IN_PROGRESS: 'Completed evidence package building',
  WORKSPACE_COMPLETED_EVIDENCE_PACKAGE_BUILD_FAILED: 'Completed evidence package failed',
  WORKSPACE_COMPLETED_EVIDENCE_PACKAGE_UPLOADED_TO_INTAKE: 'Evidence package uploaded',
  CLIENT_APPROVAL_VIEWED: 'Client approval viewed',
  CLIENT_EVIDENCE_SUBMITTED: 'Client evidence submitted',
  CLIENT_ATTESTATION_SAVED: 'Client attestation saved',
  CLIENT_DOCUMENT_METADATA_UPDATED: 'Client document metadata updated',
  CLIENT_DENIED_EVIDENCE_GENERATION: 'Denied update & evidence',
  PENDING_CLIENT_APPROVAL: 'Pending client approval',
  ORCHESTRATION_WORKER_SUCCEEDED: 'Evidence workflow completed',
  RUN_EVIDENCE_WORKFLOW: 'Readiness workflow approval',
  RUN_TECHNICAL_BASELINE: 'Readiness workflow approval',
  RUN_CDK_DEPLOYMENT: 'Software update approval',
  RUN_CLIENT_BASELINE_DEPLOY: 'Software update approval',
  RUN_DEPLOY_CLIENT_BASELINE: 'Software update approval',
  RUN_EVIDENCE_PACKAGE: 'Readiness evidence approval',
  RUN_COLLECT_EVIDENCE: 'Readiness evidence approval',
  RUN_EVIDENCE_ONLY: 'Readiness evidence approval',
  USED: 'Used',

  ACTIVITY: 'Activity',
  ADMIN_ORCHESTRATION_REQUEST: 'Admin orchestration request',
  AUDITOR_PACKAGE: 'Auditor package',
  CLIENT_REGISTRY: 'Client registry',
  CLIENT_UPLOAD: 'Client upload',
  CMMC_WORKFLOW: 'CMMC workflow',
  JOB_STATUS: 'Job status',
  PACKAGE_DOWNLOAD: 'Package download',
  PACKAGE_LIFECYCLE: 'Package lifecycle',
  REPORT_GENERATION: 'Report generation',
  CLIENT_EVIDENCE_WORKSPACE: 'Client evidence workspace',
};

export function normalizeLabelKey(value: unknown): string {
  return String(value ?? '')
    .trim()
    .replace(/[\s-]+/g, '_')
    .toUpperCase();
}

export function friendlyLabel(value: unknown): string {
  if (value === undefined || value === null) return '—';
  if (Array.isArray(value)) {
    const labels = value.map((entry) => friendlyLabel(entry)).filter((entry) => entry !== '—');
    return labels.join(', ') || '—';
  }
  if (typeof value === 'object') return JSON.stringify(value);

  const raw = String(value).trim();
  if (!raw || raw === '[]') return '—';
  return FRIENDLY_LABELS[normalizeLabelKey(raw)] || raw;
}

export function friendlyOptionLabel(value: string, emptyLabel: string): string {
  return value ? friendlyLabel(value) : emptyLabel;
}
